<div class="section">
  <div class="wrapper">
    <router-outlet></router-outlet>
  </div>
</div>